export default __webpack_public_path__ + "static/media/kananda-ferreira.0083c841.jpg";